export const barcodeLabelSize = [
  "1.25x1",
  "1.5x1",
  "2x1",
  "3x1",
  "3x2",
  "4x1",
  "4x2",
  "4x6",
] as const;
export type BarcodeLabelSize = (typeof barcodeLabelSize)[number];

export const barcodeLabelSizeDisplayText: Record<BarcodeLabelSize, string> = {
  "1.25x1": '1.25" \u00d7 1"',
  "1.5x1": '1.5" \u00d7 1"',
  "2x1": '2" \u00d7 1"',
  "3x1": '3" \u00d7 1"',
  "3x2": '3" \u00d7 2"',
  "4x1": '4" \u00d7 1"',
  "4x2": '4" \u00d7 2"',
  "4x6": '4" \u00d7 6"',
};
